import { keepPreviousData } from '@tanstack/react-query';

import { SynapseProblemID } from '@playq/octopus2-ml';
import { GenericFailure } from '@playq/services-shared';
import { SynapseProblemSchema } from '@playq/services-synapse';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const problemSchemaKeys: unknown[] = ['problem', 'schema'];

export const useProblemSchema = (
  id: SynapseProblemID,
  version?: number,
  options?: IUseQueryOptionsExtended<SynapseProblemSchema | undefined, GenericFailure | Error>
) =>
  useEitherQuery(
    problemSchemaKeys.concat(id, version),
    () => {
      if (version !== undefined) {
        return services2.synapseProblemsService.problemSchema(id, version);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
